import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "./Reveal";
import { track } from "../lib/track";

export const FinalCta = () => (
  <section data-testid="final-cta" className="bg-brand-deep">
    <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
      <div className="grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <MaskedLines
            as="h2"
            lines={["Ready For A", "Cleaner Home?"]}
            className="font-display text-4xl font-black leading-[1.05] text-white sm:text-5xl lg:text-6xl"
          />
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-teal-100/85 md:text-lg">
              Tell us what you need cleaned and where you're located, and we'll be in touch to discuss your quote.
            </p>
            <p className="mt-4 text-sm text-teal-100/60">
              Property manager or business?{" "}
              <Link to="/property-managers" className="font-semibold text-teal-200 underline-offset-4 hover:underline">
                Talk to us about an ongoing cleaning arrangement.
              </Link>
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.3} className="lg:col-span-4 lg:justify-self-end">
          <Link
            to="/contact"
            data-testid="final-cta-button"
            onClick={() => track("cta_click", { label: "final_quote" })}
            className="group inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 font-display text-base font-bold text-brand-deep shadow-xl transition-transform duration-200 hover:-translate-y-1"
          >
            Get My Free Quote
            <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
